module.exports = __webpack_public_path__ + "img/1772b5d.jpg";